import React, { useEffect, useState } from 'react';

import { FlexDiv, Container } from 'commonStyles';
import { Wrapper, SupportWrap, HeaderWrap } from './Style';
import { PATHS, INTEGRATION_AWARNESS_CONSTANTS } from 'AppConstants';
import { logOmniture } from 'UtilityComponents/intergarationUtils';
import BreadCrumb from 'common/BreadCrumb/BreadCrumb';

const Header = ({ showBreadCrumbs, headerImg = '', mailerDetails = {}, crumbData, isLanding, headerBg }) => {
	const { to, subject, message } = mailerDetails;

	const [bgColor, setBgColor] = useState(headerBg);

	const onSupportHandler = (e) => {
		e && e.stopPropagation();
		logOmniture(`support_clicked`, PATHS.TRAVEL_INTEGRATION_LANDING);
		window.location.href = `mailto:${to}?subject=${subject}&body=${message}`;
	};

	const handleScroll = () => {
		if (window.scrollY > 60) {
			setBgColor('linear-gradient(95.43deg, #072833 0.23%, #092C46 100%)');
		} else {
			setBgColor(headerBg);
		}
	};

	useEffect(() => {
		isLanding && window.addEventListener('scroll', handleScroll);
		return (() => {
			isLanding && window.removeEventListener('scroll', handleScroll);
		});
	}, []);

	const clickBreadcrumb = (item) => {
		if (item?.url) {
			window.location = item.url;
		}
	};

	return (
		<HeaderWrap position='fixed' $direction='column' $bg={bgColor} top_P='16'>

			<Wrapper justify='space-between' showBdr={showBreadCrumbs} bottom_P='16'>
				<Container>
					<img src={headerImg} width='109' />
				</Container>

			</Wrapper>

			<FlexDiv position='relative'>
				{showBreadCrumbs && crumbData?.length > 0 &&
					<>
						<BreadCrumb
							bottom_P='0'
							bottom_M={0}
							$bg='transparent'
							breadCrumbList={crumbData}
							clickAction={clickBreadcrumb}
						/>
						<SupportWrap f_size='14' onClick={onSupportHandler}>{INTEGRATION_AWARNESS_CONSTANTS.SUPPORT_TEXT}</SupportWrap>
					</>}
			</FlexDiv>
		</HeaderWrap>
	);
};

export default Header;
